import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $ = _ref.$,
      $on = _ref.$on,
      $f7 = _ref.$f7,
      $f7route = _ref.$f7route,
      $f7router = _ref.$f7router,
      $update = _ref.$update;

  /**
   * ==========================================================================
   * Questa pagina è la pagina principale per gli utenti registrati
   * e gestisce i redirect nei casi in cui l'utente non sia salvato nel device
   * oppure i dati salvati siano incompleti.
   * ==========================================================================
   */
  var avatar,
      me = {},
      qrcode = '',
      redirectToMe,
      adv = [],
      marketplace = [],
      institutes = [],
      iceNames = myApp.iceNames,
      usercode = '';
  /**
   * Elimina badge sull'icona dell'app 
   * @returns {undefined}
   */

  if ($f7.device.cordova) {
    cordova.plugins.firebase.messaging.setBadge(0);
  }
  /**
   * Mostra la pagina Marketplace se c'è qualcosa da mostrare
   * @returns {undefined}
   */


  var showMarketplace = function showMarketplace() {
    $f7router.navigate('/marketplace/');
  };
  /**
   * InAppBrouser link
   * @param {type} ev
   * @returns {undefined}
   */


  var iab = function iab(ev) {
    var data = $(ev.target).dataset();
    myApp.iab(data.href, data.target, data.options);
  };

  var isCordovaIOS = $f7.device.cordova && $f7.device.ios;
  /**
   * Services visualizzati
   * @type Array
   */

  var myservices = [{
    caption: isCordovaIOS ? lng.uniqueCode : lng.your_qrcode,
    icon: isCordovaIOS ? '<img src="static/icons/qrcode-ios.svg"/>' : '<img src="static/icons/qrcode.svg"/>',
    href: '/qrcode/'
  }, {
    id: 'ice',
    caption: lng.emergency_contacts,
    icon: '<img src="static/icons/ice.png"/>',
    href: '/ice2/',
    badge: 0
  }, {
    caption: lng.hesitates_title,
    icon: '<img src="static/icons/analysis.svg"/>',
    href: '/hesitates/'
  }, {
    caption: lng.medical_records_title,
    icon: '<img src="static/icons/medical.svg"/>',
    href: '/medical/'
  }, {
    id: 'calendar',
    caption: lng.calendar_title,
    icon: '<img src="static/icons/calendar_today.svg"/>',
    href: '/calendar/'
  }, {
    id: 'notifications',
    caption: lng.notifications,
    icon: '<img src="static/icons/bubble_left_bubble_right.svg"/>',
    href: '/notifications/',
    badge: 0
  }, {
    id: 'documents',
    caption: lng.documents_title,
    icon: '<img src="static/icons/doc_on_doc.svg"/>',
    href: '/documents/',
    badge: 0
  }, {
    caption: lng.qrscan_title,
    icon: '<img src="static/icons/qrcode_viewfinder.svg"/>',
    onClick: function onClick() {
      barcodescan();
    }
  }];
  var services = [].concat(myservices);
  /**
   * Imposta il badge per notifications
   * 
   * @param {type} usr
   * @returns {unresolved}
   */

  var badgeNotifications = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(usr) {
      var read, i;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return myStorage.get('notifications_read', true);

            case 2:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 5;
                break;
              }

              _context.t0 = [];

            case 5:
              read = _context.t0;
              usr.data.notifications = usr.data.notifications || [];
              i = usr.data.notifications.reduce(function (total, item) {
                var n = read.find(function (i) {
                  return i == item.id;
                }) ? 0 : 1;
                return total + n;
              }, 0);
              return _context.abrupt("return", i);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function badgeNotifications(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Pull To Refresh
   * @param {type} e
   * @param {type} done
   * @returns {undefined}
   */


  var ptrRefresh = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, done) {
      var usr;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              $update();
              _context3.next = 4;
              return getADV();

            case 4:
              _context3.next = 6;
              return uploadLinks();

            case 6:
              _context3.next = 8;
              return uploadUser();

            case 8:
              usr = _context3.sent;

              if (!usr) {
                _context3.next = 21;
                break;
              }

              institutes = usr.data.institutes || []; // imposta badge

              services.forEach( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, i) {
                  var TS_LIMIT;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(['notifications', 'calendar'].indexOf(e.id) > -1)) {
                            _context2.next = 11;
                            break;
                          }

                          usr.data[e.id] = usr.data[e.id] || [];
                          TS_LIMIT = Date.now() - 3600000 * myApp.calendar_hours_limit;

                          if (!(e.id == 'notifications')) {
                            _context2.next = 9;
                            break;
                          }

                          _context2.next = 6;
                          return badgeNotifications(usr);

                        case 6:
                          _context2.t0 = _context2.sent;
                          _context2.next = 10;
                          break;

                        case 9:
                          _context2.t0 = usr.data.calendar.filter(function (e) {
                            return e.ts * 1000 >= TS_LIMIT;
                          }).length;

                        case 10:
                          e.badge = _context2.t0;

                        case 11:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x4, _x5) {
                  return _ref4.apply(this, arguments);
                };
              }());
              if (myApp.children) me = usr.data.childrens.find(function (e) {
                return e.id == myApp.children;
              }).data || {};else me = usr.data;
              _context3.next = 15;
              return myStorage.get(me.avatar);

            case 15:
              _context3.t0 = _context3.sent;

              if (_context3.t0) {
                _context3.next = 18;
                break;
              }

              _context3.t0 = me.avatar;

            case 18:
              avatar = _context3.t0;
              $update();

              if (usr.data.calendar && usr.data.calendar.length && $f7.device.cordova && !myApp.FCM) {
                myApp.cordova.messaging();
                myApp.FCM = true;
              }

            case 21:
              _context3.next = 26;
              break;

            case 23:
              _context3.prev = 23;
              _context3.t1 = _context3["catch"](0);
              console.log('Error: ' + _context3.t1.message);

            case 26:
              _context3.prev = 26;
              done();
              return _context3.finish(26);

            case 29:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 23, 26, 29]]);
    }));

    return function ptrRefresh(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Aggiorna link dal server -> concatena con services
   * @returns {undefined}
   */


  var uploadLinks = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var resp, data, token, newData;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return myApp.server.get('services');

            case 3:
              resp = _context4.sent;
              _context4.next = 6;
              return resp.json();

            case 6:
              data = _context4.sent;
              _context4.next = 9;
              return myApp.server.authToken();

            case 9:
              token = _context4.sent;

              if (data.length) {
                newData = data.map(function (e) {
                  var href = e.href.replace('%token%', encodeURIComponent(btoa(token)));
                  return {
                    href: '#',
                    caption: e.caption,
                    icon: e.icon,
                    badge: e.badge,
                    onClick: function onClick() {
                      myApp.iab(href, e.target);
                    }
                  };
                });
                services = myservices.concat(newData);
                $update();
              }

              _context4.next = 17;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](0);
              services = [].concat(myservices);
              $update();

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 13]]);
    }));

    return function uploadLinks() {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * Aggiorna user dal server
   * @returns {undefined}
   */


  var uploadUser = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var usr;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return myApp.server.getJSON('user/me');

            case 3:
              usr = _context5.sent;
              return _context5.abrupt("return", myApp.user(usr));

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", myApp.user());

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 7]]);
    }));

    return function uploadUser() {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * Recupera ADV
   * @returns {undefined}
   */


  var getADV = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return myApp.server.getJSON('user/adv');

            case 2:
              adv = _context6.sent;
              $update();

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function getADV() {
      return _ref7.apply(this, arguments);
    };
  }();
  /**
   * Controlla lo stato dell'utente e reindirizza di conseguenza
   * https://framework7.io/docs/router-component.html#component-page-events
   * 
   * @param {type} ev event
   */


  $on('pageBeforeIn', /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(ev) {
      var user, resp, usr;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return myApp.user();

            case 2:
              user = _context7.sent;
              console.log('Page Before IN'); // Controlla in Storage

              if (!user) {
                _context7.next = 8;
                break;
              }

              userData();
              _context7.next = 27;
              break;

            case 8:
              _context7.prev = 8;
              _context7.next = 11;
              return myApp.server.get('user/me');

            case 11:
              resp = _context7.sent;

              if (!resp.ok) {
                _context7.next = 21;
                break;
              }

              _context7.next = 15;
              return resp.json();

            case 15:
              usr = _context7.sent;
              _context7.next = 18;
              return myApp.user(usr);

            case 18:
              userData();
              _context7.next = 22;
              break;

            case 21:
              // errore nel recupero dei dati [status] -> Gestire la risposta
              console.log(resp.status, 'Status');

            case 22:
              _context7.next = 27;
              break;

            case 24:
              _context7.prev = 24;
              _context7.t0 = _context7["catch"](8);
              // errore nel recupero dei dati [error] -> Gestire la risposta 
              console.log(_context7.t0.message, 'Error');

            case 27:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[8, 24]]);
    }));

    return function (_x6) {
      return _ref8.apply(this, arguments);
    };
  }());
  $on('pageAfterIn', function () {
    return ptrRefresh(null, function () {
      return console.log('DONE');
    });
  });
  /**
   * Evento pagina
   * https://framework7.io/docs/router-component.html#component-page-events
   * 
   * @returns {undefined}
   */

  $on('pageAfterIn', function () {
    console.log('Page After IN');
    if ($f7.device.android) $f7router.clearPreviousHistory();
    if (redirectToMe) return $f7router.navigate('/me/', {
      animate: false,
      clearPreviousHistory: true
    });

    if ($f7route.query.showPopoverICE === 'yes') {
      $f7.popover.open('.popover-ice', '.btn-menu', true);
      setTimeout(closePopover, 20000);
      $(window).click(closePopover);
    }

    if (myApp.badgeNotificationsUpdated) {
      myApp.user().then(function (usr) {
        return badgeNotifications(usr);
      }).then(function (n) {
        var service_notifications = services.find(function (item) {
          return item.id == 'notifications';
        });
        service_notifications.badge = n;
        $update();
        myApp.badgeNotificationsUpdated = false;
      });
    }
  });
  /**
   * Chiude popover ICE
   * @returns {undefined}
   */

  var closePopover = function closePopover() {
    $f7.popover.close('.popover-ice');
  };
  /**
   * Scan QRCode.
   * Usa phonegap-plugin-barcodescanner
   * https://github.com/phonegap/phonegap-plugin-barcodescanner
   * 
   * Se il codice trovato corrisponde a qrscanpattern:
   *  - Se l'utente è main e non ha una card associata apre Action Sheet con opzione di associare card
   *  - In tutti gli altri casi apre il collegamento 
   * 
   */


  var barcodescan = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var result, usr;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;

              if (!$f7.device.cordova) {
                _context8.next = 7;
                break;
              }

              _context8.next = 4;
              return myApp.cordova.qrscan();

            case 4:
              result = _context8.sent;
              _context8.next = 10;
              break;

            case 7:
              _context8.next = 9;
              return $f7.pwaQrcodeScanner();

            case 9:
              result = _context8.sent;

            case 10:
              if (!(result && result.text)) {
                _context8.next = 21;
                break;
              }

              if (!result.text.match(myApp.qrscanpattern)) {
                _context8.next = 18;
                break;
              }

              _context8.next = 14;
              return myApp.user();

            case 14:
              usr = _context8.sent;

              // scenario a) Utente senza card associata
              if (!usr.cardnumber && !myApp.children) {
                $f7.actions.create({
                  buttons: [{
                    label: true,
                    text: lng.associate_card_question_message,
                    color: 'gray'
                  }, {
                    // Associa card
                    icon: '<i class="icon f7-icons">checkmark_alt</i>',
                    text: lng.associate_card,
                    color: 'blue',
                    onClick: function onClick() {
                      $f7.preloader.show();
                      myApp.server.putJSON('user/me/cardnumber?children=' + (myApp.children || ''), result).then(function () {
                        return $f7.toastSuccess(lng.associate_card_ok_message);
                      }).catch(function (e) {
                        return $f7.alertError(e);
                      }).finally(function () {
                        return $f7.preloader.hide();
                      });
                    }
                  }, {
                    // Visualizza data
                    icon: '<i class="icon f7-icons">doc_person</i>',
                    text: lng.view_data_without_associate,
                    color: 'blue',
                    onClick: function onClick() {
                      myApp.iab(result.text, '_system');
                    }
                  }, {
                    text: lng.cancel,
                    color: 'red'
                  }]
                }).open();
              } else {
                // Scenario b) Utente con card già associata
                //myApp.iab(result.text, '_system')
                result.text.match(/^https?:\/\//) ? myApp.iab(result.text, '_system') : $f7.dialog.alert(result.text);
              }

              _context8.next = 19;
              break;

            case 18:
              // qrcode da telefono oppure qualunque qrcode 
              //myApp.iab(result.text, '_system');
              result.text.match(/^https?:\/\//) ? myApp.iab(result.text, '_system') : $f7.dialog.alert(result.text);

            case 19:
              _context8.next = 22;
              break;

            case 21:
              $f7.dialog.alert('Not result text');

            case 22:
              _context8.next = 27;
              break;

            case 24:
              _context8.prev = 24;
              _context8.t0 = _context8["catch"](0);
              $f7.toastError(lng.error_message);

            case 27:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 24]]);
    }));

    return function barcodescan() {
      return _ref9.apply(this, arguments);
    };
  }();
  /**
   * Controlla dati utente
   * Se non ci sono o sono incompleti reindirizza alla pagina /me/
   * Controlla anche i dati ICE e la cartella clinica, mostrando un avviso se non sono impostati
   * 
   * @param {type} getUserData
   * @returns {undefined}
   */


  var userData = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(getUserData) {
      var usr, dataOk, notifications;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return myApp.user();

            case 2:
              _context9.t0 = _context9.sent;

              if (_context9.t0) {
                _context9.next = 5;
                break;
              }

              _context9.t0 = {
                data: {}
              };

            case 5:
              usr = _context9.t0;
              // controlla dati richiesti
              dataOk = myApp.userDataRequired.split(',').every(function (key) {
                return usr.data[key];
              }); // dati completi

              if (!dataOk) {
                _context9.next = 62;
                break;
              }

              // dati completi. Imposta valori.
              myApp.userLoggedIn = true;

              if (myApp.children) {
                me = usr.data.childrens.find(function (e) {
                  return e.id == myApp.children;
                }).data || {};
              } else {
                me = usr.data;
              }

              _context9.next = 12;
              return myStorage.get(me.avatar);

            case 12:
              _context9.t1 = _context9.sent;

              if (_context9.t1) {
                _context9.next = 15;
                break;
              }

              _context9.t1 = me.avatar;

            case 15:
              avatar = _context9.t1;
              usercode = Number(usr.username.replace(/[^0-9]/g, '') * 1).toString(16);
              notifications = services.find(function (item) {
                return item.id == 'notifications';
              });
              _context9.next = 20;
              return badgeNotifications(usr);

            case 20:
              notifications.badge = _context9.sent;
              _context9.next = 23;
              return myApp.getMarketplace();

            case 23:
              marketplace = _context9.sent;
              _context9.next = 26;
              return $update();

            case 26:
              if (!(!myApp.questionICE && (!usr.data.ice || !(usr.data.ice.ice1 && usr.data.ice.ice1name)))) {
                _context9.next = 31;
                break;
              }

              myApp.questionICE = true; // chiede d'impostare ICE. Se confermato dall'utente redirige alla pagina

              $f7.dialog.confirm(lng.ice_data_empty_question, function () {
                return $f7router.navigate('/ice/');
              });
              _context9.next = 50;
              break;

            case 31:
              if (!(!myApp.questionClinic && !usr.data.medical)) {
                _context9.next = 36;
                break;
              }

              myApp.questionClinic = true; // chiede d'impostare Cartella Medica. Se confermato dall'utente redirige alla pagina

              $f7.dialog.confirm(lng.medical_records_empty_question, function () {
                return $f7router.navigate('/medical/?edit=1');
              });
              _context9.next = 50;
              break;

            case 36:
              _context9.next = 38;
              return myStorage.get('popoverMenuView');

            case 38:
              _context9.t3 = !_context9.sent;

              if (!_context9.t3) {
                _context9.next = 41;
                break;
              }

              _context9.t3 = !myApp.popoverMenuView;

            case 41:
              _context9.t2 = _context9.t3;

              if (!_context9.t2) {
                _context9.next = 44;
                break;
              }

              _context9.t2 = !$f7route.query.showPopoverICE;

            case 44:
              if (!_context9.t2) {
                _context9.next = 50;
                break;
              }

              $('#popover-menu-never-show-container').removeClass('hidden');
              $f7.popover.open('.popover-ice', '.btn-menu', true);
              setTimeout(closePopover, 10000);
              myApp.popoverMenuView = 'yes';
              $('.popover-backdrop').click(function (ev) {
                return closePopover();
              });

            case 50:
              institutes = usr.data.institutes || [];
              $update();
              _context9.next = 54;
              return getADV();

            case 54:
              _context9.next = 56;
              return uploadLinks();

            case 56:
              _context9.next = 58;
              return getAvatar();

            case 58:
              _context9.next = 60;
              return syncImages();

            case 60:
              _context9.next = 64;
              break;

            case 62:
              redirectToMe = true;
              goToMe();

            case 64:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function userData(_x7) {
      return _ref10.apply(this, arguments);
    };
  }();

  var getAvatar = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var data;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return myStorage.get(me.avatar);

            case 2:
              data = _context10.sent;

              if (!data) {
                _context10.next = 5;
                break;
              }

              return _context10.abrupt("return", true);

            case 5:
              _context10.next = 7;
              return $f7.fetchImage(me.avatar);

            case 7:
              data = _context10.sent;
              if (data) myStorage.set(me.avatar, data);

            case 9:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function getAvatar() {
      return _ref11.apply(this, arguments);
    };
  }();

  var syncImages = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var user;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return myApp.user();

            case 2:
              user = _context11.sent;
              if (user.data.medical.images && user.data.medical.images.length) user.data.medical.images.forEach(function (e) {
                return fetchImages(e.src);
              });
              if (user.data.medical.qrcodes && user.data.medical.qrcodes.length) user.data.medical.qrcodes.forEach(function (e) {
                return fetchImages(e.src);
              });

            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function syncImages() {
      return _ref12.apply(this, arguments);
    };
  }();

  var fetchImages = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(url) {
      var data;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return myStorage.get(url);

            case 2:
              data = _context12.sent;

              if (!data) {
                _context12.next = 5;
                break;
              }

              return _context12.abrupt("return", true);

            case 5:
              _context12.next = 7;
              return $f7.fetchImage(url);

            case 7:
              data = _context12.sent;
              if (data) myStorage.set(url, data);

            case 9:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function fetchImages(_x8) {
      return _ref13.apply(this, arguments);
    };
  }();
  /**
   * Imposta visualizzazione del popover menu
   * @returns {undefined}
   */


  var setPopoverView = function setPopoverView() {
    if ($('#popover-menu-never-show').prop('checked')) myStorage.set('popoverMenuView', 1);
  };
  /**
   * Reindirizza alla pagina dei dati personali
   */


  var goToMe = function goToMe() {
    $f7router.navigate('/me/');
  };

  var deleteItem = function deleteItem(evt) {
    $f7.dialog.confirm(lng.deleteSelectedService, function () {
      var mp = adv.filter(function (item) {
        return !item.fixed;
      });
      var dif = adv.length - mp.length;
      var idx = evt.target.dataset.id * 1 - dif;
      $f7.preloader.show();
      myApp.server.deleteJSON('marketplace/' + idx).then(function () {
        return getADV();
      }).then(function () {
        return uploadLinks();
      }).catch(function (e) {
        return console.log(e);
      }).finally(function () {
        return $f7.preloader.hide();
      }).then(function () {
        return $update();
      });
    });
  };

  var deleteInstitution = function deleteInstitution(evt) {
    $f7.dialog.confirm(lng.deleteSelectedService, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var usr;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              console.log(evt.target.dataset.id);
              _context13.next = 3;
              return myApp.user();

            case 3:
              usr = _context13.sent;
              console.log(usr);
              institutes = usr.data.institutes.filter(function (item) {
                return item.name !== evt.target.dataset.id;
              });
              usr.data.institutes = institutes;
              _context13.next = 9;
              return myApp.server.postJSON('institutions', usr.data.institutions);

            case 9:
              myApp.user(usr);
              $update();

            case 11:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    })));
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="services">

    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <div class="avatar-small margin-left-half" style="background-image: url(${avatar})"></div>
        </div>
        <div class="title">${me.name}</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open btn-menu" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
      </div>
    </div>

    <div class="popover popover-ice theme-dark" @popover:close=${setPopoverView}>
      <div class="popover-inner">
        <a href="#" @click=${closePopover} style="position: absolute; top: 5px; right: 12px">
          <i class="f7-icons">xmark_circle_fill</i>
        </a>
        <div class="block">
          <h3>Menu</h3>
          <p>
            <img width="28" src='static/menu.png' class="float-left margin-half"/> 
            ${lng.services_popover_text}
          </p>

          <div id='popover-menu-never-show-container' class='hidden'>
            <label for='popover-menu-never-show'>${lng.do_not_show_again}</label>
            <input type='checkbox' class='margin-left' id='popover-menu-never-show' /> 
          </div>

        </div>
      </div>
    </div>

    <div class="page-content ptr-content unselectable" @ptr:refresh=${ptrRefresh}>

      <div class="ptr-preloader">
        <div class="preloader"></div>
        <div class="ptr-arrow"></div>
      </div>

      <div class="row services-items-container">

        <div class="margin mt-0">
          <img width="100%" src="static/logo.png" />
        </div>

        ${services.map((item) => $h`
        <div class="col-50 services-item-container">
          <a href="${item.href || '#'}" class="services-item ${
               item.class || ''
             }" innerHTML="${item.icon}" @click=${item.onClick}></a>
          <div class="item-caption">${item.caption}</div>
          ${item.badge > 0 && $h`
          <span class="badge color-secondary">${item.badge}</span>
          `}
        </div>
        `)}


        <div class="col-100">
          <hr class="hr-soft" />
          <div class="text-align-center">${lng.select}</div>
          <button @click=${showMarketplace} class="button button-large button-fill button-round color-secondary margin-bottom-half">
            <i class="f7-icons left">gift</i> ${lng.marketplace_explore} 
          </button>
        </div>



        <div class="col-100">
          <hr class="hr-soft" />
          <h3 @click=${showMarketplace} class="text-color-primary">
            ${lng.conventions_and_services}
          </h3>
          <hr class="hr-soft" />
        </div>


        <div class="list">
          <ul class="bg-transparent">


            ${institutes.map((item,idx) => $h`
            <li>
              <div class="item-inner">
                <img class="adv" data-target="_system" data-href="${item.link}" @click=${iab} src="${item.banner}"/>
                <a href="#" @click=${deleteInstitution} data-id="${item.name}">
                  <div class="delete-item" data-id="${item.name}"><i data-id="${item.name}" class="f7-icons">trash_circle_fill</i></div>
                </a>
              </div>
            </li>
            `)} 

            ${adv.map((item,idx) => $h`
            <li>
              <div class="item-inner">
                <img class="adv" data-target="_system" data-href="${item.href}" @click=${iab} src="${item.src}"/>
                ${!item.fixed ? $h`
                <a href="#" @click=${deleteItem} data-id="${idx}">
                  <div class="delete-item" data-id="${idx}"><i data-id="${idx}" class="f7-icons">trash</i></div>
                </a>
                `:''}
              </div>
            </li>
            `)} 

            ${adv.length === 0 ? $h`
            <div class="block">
              <h4 innerHTML=${lng.noAdvMessage}></h4>
            </div>
            `:''}

          </ul>
        </div>

      </div>

      <div style="height: 5em"></div>

      <div class="my-footer padding-bottom">
        <hr class="sep"/>
        <a href="http://www.processfarm.net" class="link external text-color-black" target="_system">
          <span>Prodotto da <img class="process-services" src="static/process-services.png"/> srl Società Benefit 
            <br/> 01549880050 - www.processfarm.net</span>
        </a>
      </div>
    </div>

  </div>
`
    }
    ;
});